"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetQueryFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const QueryFieldKey_1 = __importDefault(require("../QueryFieldKey"));
exports.AssetQueryFields = {
    [QueryFieldKey_1.default.ASSET_TYPE]: {
        key: QueryFieldKey_1.default.ASSET_TYPE,
        fieldType: StaticFieldType_1.default.ASSET_TYPE,
        label: () => lib_i18n_1.default.t('type'),
    },
    [QueryFieldKey_1.default.ASSET]: {
        key: QueryFieldKey_1.default.ASSET,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        label: () => lib_i18n_1.default.t('asset'),
    },
    [QueryFieldKey_1.default.ASSET_SENSOR_TEMPERATURE]: {
        key: QueryFieldKey_1.default.ASSET_SENSOR_TEMPERATURE,
        fieldType: BasicFieldType_1.default.TEMPERATURE,
        label: () => lib_i18n_1.default.t('temperature'),
    },
    [QueryFieldKey_1.default.ASSET_SENSOR_HUMIDITY]: {
        key: QueryFieldKey_1.default.ASSET_SENSOR_HUMIDITY,
        fieldType: BasicFieldType_1.default.NUMBER,
        label: () => lib_i18n_1.default.t('humidity'),
    },
    [QueryFieldKey_1.default.ASSET_SENSOR_WATER_PRESENT]: {
        key: QueryFieldKey_1.default.ASSET_SENSOR_WATER_PRESENT,
        fieldType: BasicFieldType_1.default.BOOLEAN,
        label: () => lib_i18n_1.default.t('water-present'),
    },
    [QueryFieldKey_1.default.ASSET_SENSOR_OBJECT_PRESENT]: {
        key: QueryFieldKey_1.default.ASSET_SENSOR_OBJECT_PRESENT,
        fieldType: BasicFieldType_1.default.BOOLEAN,
        label: () => lib_i18n_1.default.t('object-present'),
    },
    [QueryFieldKey_1.default.ASSET_MANUFACTURER]: {
        key: QueryFieldKey_1.default.ASSET_MANUFACTURER,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('manufacturer'),
    },
    [QueryFieldKey_1.default.ASSET_MODEL]: {
        key: QueryFieldKey_1.default.ASSET_MODEL,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('model'),
    },
    [QueryFieldKey_1.default.ASSET_SERIALNO]: {
        key: QueryFieldKey_1.default.ASSET_SERIALNO,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('serial-number'),
    },
    [QueryFieldKey_1.default.ASSET_HASSENSOR]: {
        key: QueryFieldKey_1.default.ASSET_HASSENSOR,
        fieldType: BasicFieldType_1.default.BOOLEAN,
        label: () => lib_i18n_1.default.t('has-sensor'),
    },
    [QueryFieldKey_1.default.ASSET_LASTSERVICEDATE]: {
        key: QueryFieldKey_1.default.ASSET_LASTSERVICEDATE,
        fieldType: BasicFieldType_1.default.DATE,
        label: () => lib_i18n_1.default.t('last-service'),
    },
    [QueryFieldKey_1.default.ASSET_CUSTOMFIELD_0]: {
        key: QueryFieldKey_1.default.ASSET_CUSTOMFIELD_0,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('customField0'),
    },
    [QueryFieldKey_1.default.ASSET_CUSTOMFIELD_1]: {
        key: QueryFieldKey_1.default.ASSET_CUSTOMFIELD_1,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('customField1'),
    },
    [QueryFieldKey_1.default.ASSET_CUSTOMFIELD_2]: {
        key: QueryFieldKey_1.default.ASSET_CUSTOMFIELD_2,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('customField2'),
    },
    [QueryFieldKey_1.default.ASSET_CUSTOMFIELD_3]: {
        key: QueryFieldKey_1.default.ASSET_CUSTOMFIELD_3,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('customField3'),
    },
    [QueryFieldKey_1.default.ASSET_CUSTOMFIELD_4]: {
        key: QueryFieldKey_1.default.ASSET_CUSTOMFIELD_4,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('customField4'),
    },
    [QueryFieldKey_1.default.ASSET_CUSTOMFIELD_5]: {
        key: QueryFieldKey_1.default.ASSET_CUSTOMFIELD_5,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('customField5'),
    },
    [QueryFieldKey_1.default.ASSET_CUSTOMFIELD_6]: {
        key: QueryFieldKey_1.default.ASSET_CUSTOMFIELD_6,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('customField6'),
    },
    [QueryFieldKey_1.default.ASSET_CUSTOMFIELD_7]: {
        key: QueryFieldKey_1.default.ASSET_CUSTOMFIELD_7,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('customField7'),
    },
    [QueryFieldKey_1.default.ASSET_CUSTOMFIELD_8]: {
        key: QueryFieldKey_1.default.ASSET_CUSTOMFIELD_8,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('customField8'),
    },
    [QueryFieldKey_1.default.ASSET_CUSTOMFIELD_9]: {
        key: QueryFieldKey_1.default.ASSET_CUSTOMFIELD_9,
        fieldType: BasicFieldType_1.default.STRING,
        label: () => lib_i18n_1.default.t('customField9'),
    },
};
exports.default = exports.AssetQueryFields;
